import { useRef, useState, useEffect } from 'react';
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"
import DescriptionControl from "../../../Controls/DescriptionControl"
import { useNavigate } from "react-router-dom";
import TextAreaControl from "../../../Controls/TextAreaControl";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { 
	GetLocal,
	SetLocal,
	FetchService,
	IsEmptyInput
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let ServiceUrlCheckBox = '';
let ShowSuccess = null;

export default function Index(props) {
    const inputRef = useRef(null);
	const navigate = useNavigate();
	
	const inpFilesRef = useRef(null);
	const inpDescriptionRef = useRef(null);
	
    const [value, setValue] = useState(0);
	const inpTelRef = useRef(null);
	const [getServiceResult, setServiceResult] = useState(false);
	const [getSelectData, setSelectData] = useState([]);
	const [getFileNumberState,setFileNumberState] = useState(true);
	
    useEffect(() => {
		SetTypeLevel('GetReviewReportByAllFiles');
    }, []);	
	
	const GetReviewReportByFileNumber = ()=>{
		if(IsEmptyInput(inpFilesRef))
			return false;
		
        var inputValue = {
			  session: GetLocal('EmployeeSession'),
			  fileNumber: Number(inpFilesRef.current.value)			  
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Request/GetReviewReportByFileNumber", inputValue, GetReviewReportByFileNumberSuccess, ServiceResultFail);		
	}
	
	const GetReviewReportByFileNumberSuccess =(ServiceResult)=>{
		setServiceResult([ServiceResult]);
	}
	
	const GetReviewReportByAllFiles = ()=>{	
        var inputValue = {
			  session: GetLocal('EmployeeSession')		  
        };
        FetchService("Employee/Urbanization/Request/GetReviewReportByAllFiles", inputValue, GetReviewReportByAllFilesSuccess, ServiceResultFail);		
	}
	
	const GetReviewReportByAllFilesSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult.FileListResult);
		if(ShowSuccess)
			toast.success('اطلاعات شما با موفقیت ذخیره گردید');
		ShowSuccess = null;
	}	

	const ServiceResultFail =(ServiceResult)=>{
		setServiceResult([]);
	}	
	
	const ClearRefInput = ()=>{
		inpFilesRef.current.value = ""; 
	}

	const ShowFilesOperationAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.OperationInfo)			
	}
	
	const SelectEditAction =(row)=>{
		SetLocal('FileNumber',Number(row.FileNumber)); 
		navigate("/Employee/ShowReviewDetailEmployee?page=جزییات گزارش بازدید");
	}
	
	let customRenderCell = {
		FileNumber: (row) => (
			row.ForeColor == 1 ? 
			<div class="text-danger">{row.FileNumber}</div>
			:
			<div>{row.FileNumber}</div>
		),
		LastRequestDate: (row) => (
			row.ForeColor == 1 ? 
			<div class="text-danger">{row.LastRequestDate}</div>
			:
			<div>{row.LastRequestDate}</div>
		),
		RegistrationPlaque: (row) => (
			row.ForeColor == 1 ? 
			<div class="text-danger">{row.RegistrationPlaque}</div>
			:
			<div>{row.RegistrationPlaque}</div>
		),
		RenovationCode: (row) => (
			row.ForeColor == 1 ? 
			<div class="text-danger">{row.RenovationCode}</div>
			:
			<div>{row.RenovationCode}</div>
		),
		FullName: (row) => (
			row.ForeColor == 1 ? 
			<div class="text-danger">{row.FullName}</div>
			:
			<div>{row.FullName}</div>
		),
		Address: (row) => (
			row.ForeColor == 1 ? 
			<div class="text-danger">{row.Address}</div>
			:
			<div>{row.Address}</div>
		)		
	};	
	
	const DataGrid =()=>{				
		return (
			<GridControl
				data={getServiceResult}
				customHeaders={{"FileNumber": "شماره پرونده","LastRequestDate": "تاریخ آخرین اقلام","RegistrationPlaque": "پلاک ثبتی","RenovationCode":"کد نوسازی","FullName":"نام مالک","Address":"آدرس","SelectEditAction":"ویرایش"}}	
				SelectEditAction={SelectEditAction}
				customRenderCell={customRenderCell}
			/>
		)		
	}	
	
	const SetTypeLevel =(val)=>{
		ServiceUrlCheckBox = val;
		ClearRefInput();
		setServiceResult([]);

		if(val == 'GetReviewReportByFileNumber')
			setFileNumberState(false);	
		else
			setFileNumberState(true);	
	}
	
	const BtnGetServiceResult = ()=>{
		if(ServiceUrlCheckBox == 'GetReviewReportByFileNumber')
			GetReviewReportByFileNumber();
		
		if(ServiceUrlCheckBox == 'GetReviewReportByAllFiles')
			GetReviewReportByAllFiles();
	}	

    return (
		<div class="text-center my-4">
			<table dir="rtl" className="col col-sm-12 col-md-6">
				<tbody>
				<tr>
					<td style={{"width": "10%"}}><input onClick={()=>SetTypeLevel('GetReviewReportByFileNumber')} checked={getFileNumberState == 0} type="radio" name="FilesRadio" className="align-bottom" /></td>
					<td style={{"width": "30%"}}>شماره پرونده</td>
					<td style={{"width": "100%"}}>
						<TextBoxNumericControl
							required={true}
							className="mt-3"
							maxlength={11}
							inputRef={inpFilesRef}
							disabled={getFileNumberState}
							placeholder="شماره پرونده"
						/>					
					</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>
				<tr>
					<td style={{"width": "17px"}}><input onClick={()=>SetTypeLevel('GetReviewReportByAllFiles')} checked={getFileNumberState == 1} type="radio" name="FilesRadio" className="align-bottom" /></td>
					<td style={{"width": "10px"}}>کلیه پرونده ها</td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
					<td style={{"width": "50px"}}></td>
				</tr>	
				<tr>
					<td colspan="7" className="text-end">
						<ButtonControl 
							variant="primary float-left w-25 mx-2"
							title="جستجو"
							onClick={BtnGetServiceResult}
							icon="fa fa-search"
						/>						
					</td>
				</tr>	
				</tbody>
			</table>
			
			<hr/>
			
			<div id="GetReviewReport">
				<DataGrid/>
			</div>
		</div>
    );
}
